import React, { useEffect } from "react";
import axios from "axios";

const categorias = {
  "Higiene y cuidado de la piel": "05",
  "Capilar": "01",
  "Maquillaje": "06",
  "Facial": "04",
  "Perfumería": "02"
};

export const TestCategorias = () => {
  const testearCategorias = async () => {
    console.log("🚀 INICIANDO TEST DE CATEGORÍAS");
    console.log("=".repeat(50));
    
    let totalProductos = 0;
    let totalSubLineas = 0;
    let exitosas = 0;
    let errores = 0;

    for (const [categoria, id] of Object.entries(categorias)) {
      console.log(`\n📋 Probando: ${categoria} (ID: ${id})`);
      
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/productos/categoria?id=${id}&page=1&pageSize=1000&`
        );

        const detalle = response?.data?.detalle;
        const totalPages = response?.data?.totalPages;
        const totalItems = response?.data?.totalItems;

        // Procesar sublíneas únicas
        const subLineas = {};
        if (detalle && Array.isArray(detalle)) {
          detalle.forEach((item) => {
            if (!subLineas[item.sublinea_id]) {
              subLineas[item.sublinea_id] = {
                sublinea_id: item.sublinea_id,
                descripcion_sublinea: item.descripcion_sublinea,
              };
            }
          });
        }

        const cantidadProductos = detalle ? detalle.length : 0;
        const cantidadSubLineas = Object.keys(subLineas).length;
        
        totalProductos += cantidadProductos;
        totalSubLineas += cantidadSubLineas;
        exitosas++;

        console.log(`✅ ${categoria}:`);
        console.log(`   - Productos: ${cantidadProductos}`);
        console.log(`   - Sublíneas: ${cantidadSubLineas}`);
        console.log(`   - Páginas totales: ${totalPages}`);
        console.log(`   - Items totales: ${totalItems}`);

        if (cantidadSubLineas > 0) {
          console.log(`   - Sublíneas encontradas:`);
          Object.values(subLineas).slice(0, 3).forEach((sublinea, index) => {
            console.log(`     ${index + 1}. ${sublinea.descripcion_sublinea} (ID: ${sublinea.sublinea_id})`);
          });
          if (cantidadSubLineas > 3) {
            console.log(`     ... y ${cantidadSubLineas - 3} más`);
          }
        }

      } catch (error) {
        errores++;
        console.log(`❌ ${categoria}:`);
        console.log(`   - Error: ${error.message}`);
        console.log(`   - Status: ${error.response?.status}`);
        if (error.response?.data) {
          console.log(`   - Respuesta:`, error.response.data);
        }
      }
    }

    console.log("\n" + "=".repeat(50));
    console.log("📊 RESUMEN FINAL:");
    console.log(`   - Categorías exitosas: ${exitosas}/5`);
    console.log(`   - Categorías con errores: ${errores}/5`);
    console.log(`   - Total productos: ${totalProductos}`);
    console.log(`   - Total sublíneas: ${totalSubLineas}`);
    console.log("=".repeat(50));
  };

  useEffect(() => {
    testearCategorias();
  }, []);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h2>🔍 Test de Categorías</h2>
      <p>Revisa la consola del navegador para ver los resultados</p>
      <button 
        onClick={testearCategorias}
        style={{
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          marginTop: "10px"
        }}
      >
        🔄 Volver a probar
      </button>
    </div>
  );
}; 